// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { ListModel } from 'types/models';

export const getListById = (
  state: State,
  idList: string,
): ListModel | undefined =>
  state.models.lists.find((list: ListModel) => list.id === idList);



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/lists.ts